
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

import './international-integration-error.css'
import { formatNumber } from 'utils/format'
import { formatDeliveryTime, showDeliveryTime } from 'utils/delivery-time'
import { TextSpan } from 'components/text-label'

import Button from "components/button";

import Fetch from "utils/fetch";
import OntimeLogo from './ontime-logo.svg';

class OntimeInternationalIntegrationError extends Component{

  static propTypes = {
    qtde: PropTypes.number.isRequired,
    data: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        IdLoadCompositionNegotiation: PropTypes.number,
        IdComposicao: PropTypes.number,
      })
    ]).isRequired,
    dataColeta: PropTypes.string.isRequired,
    nomeFornecedor: PropTypes.string,
    nomeFornecedorAnterior: PropTypes.string,
    material: PropTypes.string,
    materialAnterior: PropTypes.string,
    horaEntrega: PropTypes.string,
    dataEntrega: PropTypes.string,
    orderData: PropTypes.shape({
      IdLoadCompositionNegotiation: PropTypes.number,
      IdComposicao: PropTypes.number,
    }),
    handleFetch: PropTypes.func.isRequired,
    idPedido: PropTypes.number.isRequired,
    handleFeedback: PropTypes.func.isRequired,
    refreshTimeLine: PropTypes.func.isRequired,
  }

  render() {
    const { 
      dataColeta, 
      data, 
      dataEntrega,
      qtde, 
      nomeFornecedor, 
      nomeFornecedorAnterior, 
      material, 
      materialAnterior, 
      horaEntrega 
    } = this.props;

    const deliveryDate = typeof data === 'string' ? data : (dataEntrega || '');

    return (
      <div style={{ marginLeft: "40px", marginRight:"20px", marginBottom: "10px" }}>
        {/* Error Header */}
        <div className="error-header">
          <div className="error-message">
            This issue cannot be resolved automatically. <strong>Please contact the International Analyst responsible for your flow before resubmitting the order.</strong>
          </div>
        </div>

        {/* Ontime Info Box */}
        <div className="ontime-info-box">
          <img src={OntimeLogo} alt="Ontime International" className="ontime-logo" />
          
          <div className="negotiation-read-offer">
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.collect')}</span>
            <span>{dataColeta}</span>
          </div>
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.delivery')}</span>
            <span>{deliveryDate}</span>
          </div>
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.qty')}</span>
            <TextSpan>{`${formatNumber(qtde)}`}</TextSpan>
          </div>
        </div>
        <div className="negotiation-read-offer">
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.supplier')}</span>
            <span>{nomeFornecedor}</span>
          </div>
          <div className="negotiation-read-column">
            <span />
            <span />
          </div>
        </div>
        {
          showDeliveryTime(horaEntrega) &&
          <div className="negotiation-read-offer">
            <div className="negotiation-read-column">
              <span>{intl.get('commons.deliveryTime')}:</span>
              <span>{formatDeliveryTime(horaEntrega)}</span>
            </div>
            <div className="negotiation-read-column">
              <span />
              <span />
            </div>
          </div>
        }

        {nomeFornecedorAnterior &&
          <div className="negotiation-read-offer">
            <div className="negotiation-read-column">
              <span>{intl.get('stocks.timeline.previousSupplier')}</span>
              <span>{nomeFornecedorAnterior}</span>
            </div>
            <div className="negotiation-read-column">
              <span />
              <span />
            </div>
          </div>
        }
        {material &&
          <div className="negotiation-read-offer">
            <div className="negotiation-read-column">
              <span>{intl.get('stocks.timeline.material')}</span>
              <span>{material}</span>
            </div>
            <div className="negotiation-read-column">
              <span />
              <span />
            </div>
          </div>
        }
        {materialAnterior &&
          <div className="negotiation-read-offer">
            <div className="negotiation-read-column">
              <span>{intl.get('stocks.timeline.previousMaterial')}</span>
              <span>{materialAnterior}</span>
            </div>
            <div className="negotiation-read-column">
              <span />
              <span />
            </div>
          </div>
        }
        </div>
        
        <div className="table-list-center">
          <Button
            value="Resubmit Order"
            onClick={this.repostOrder}
            buttonType="primary"
            style={{ width: "200px" }}
          />
        </div>
      </div>
      )
    }

  repostOrder = () => {
    const { data, orderData } = this.props;
    
    // Support both data as object or orderData prop
    const dataSource = typeof data === 'object' ? data : orderData;
    const { IdLoadCompositionNegotiation, IdComposicao } = dataSource || {};

    this.props.handleFetch();

    return Fetch.post("international-orders:repost-order", {
      LoadCompositionId: IdLoadCompositionNegotiation || IdComposicao,
      OrderId: this.props.idPedido,
    })
      .then(() => {
        this.props.handleFeedback(
          intl.get("stocks.timeline.feedback.orderSavedSuccessfully")
        );
        this.props.refreshTimeLine();
      })
      .catch((e) => this.processErro(e))
      .finally(() => this.props.handleFetch(false));
  };

  processErro = (exception) => {
    const errorMessage = exception.response?.status === 400
      ? exception.response?.data?.Message || intl.get('stocks.timeline.feedback.serverError')
      : intl.get('stocks.timeline.feedback.serverError');
    
    this.props.handleFeedback(
      intl.get('stocks.timeline.feedback.errorFound'),
      errorMessage
    );
  };
}

export default OntimeInternationalIntegrationError
